<template>
  <main v-if="visible">
    <Loader
      v-if="loader"
      style="margin-left: auto; margin-right: auto; display: block"
    />
    <!-- Empresa -->
    <transition name="fade">
      <template v-if="formInfoEmpresa.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="formInfoEmpresa.showForm = !formInfoEmpresa.showForm"
          >
            4.1 - INFORMAÇÕES DA EMPRESA
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formInfoEmpresa.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formInfoEmpresa.showForm">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEmpresa.razaoSocial"
                      :form="formInfoEmpresa"
                      label="Razão Social"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEmpresa.email"
                      :form="formInfoEmpresa"
                      validationType="email"
                      label="Email"
                      type="email"
                      id="email1"
                      placeholder="Digite"
                      :disabled="formInfoEmpresa.disabledEmail"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEmpresa.grupoAtividadeEconomica"
                      :form="formInfoEmpresa"
                      type="select"
                      :options="formInfoEmpresa.optionsGrupoEconomica"
                      label="Grupo de Atividade Econômica"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEmpresa.atividadeEconomica"
                      :form="formInfoEmpresa"
                      type="select"
                      :options="formInfoEmpresa.optionsAtividadeEconomica"
                      label="Atividade Economica"
                      placeholder="Digite"
                      :disabled="formInfoEmpresa.disabledAtividade"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEmpresa.naturezaJuridica"
                      :form="formInfoEmpresa"
                      type="select"
                      :options="formInfoEmpresa.optionsNaturezaJuridica"
                      label="Natureza Jurídica"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEmpresa.telefone"
                      :form="formInfoEmpresa"
                      label="Telefone Celular"
                      id="TelefoneCelular"
                      placeholder="(##) #####-####"
                      :mask="'(##) #####-####'"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoEmpresa.faturamentoMensal"
                      :form="formInfoEmpresa"
                      type="money"
                      validationType="billingSantander"
                      label="Faturamento Mensal"
                      placeholder="Digite"
                    />
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <!-- Endereco -->
    <transition name="fade">
      <template v-if="formInfoEndereco.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="formInfoEndereco.showForm = !formInfoEndereco.showForm"
          >
            4.2 - INFORMAÇÕES DE ENDEREÇO
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formInfoEndereco.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formInfoEndereco.showForm">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formInfoEndereco.cep"
                      :form="formInfoEmpresa"
                      label="CEP"
                      id="CEP"
                      placeholder="Digite"
                      :mask="'#####-###'"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-9">
                    <form-helper
                      :inputVar="formInfoEndereco.endereco"
                      :form="formInfoEmpresa"
                      label="Endereço"
                      id="Endereco"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formInfoEndereco.numero"
                      :form="formInfoEmpresa"
                      type="number"
                      :min="0"
                      label="Número"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formInfoEndereco.complemento"
                      :form="formInfoEmpresa"
                      label="Complemento"
                      id="Complemento1"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoEndereco.bairro"
                      :form="formInfoEmpresa"
                      label="Bairro"
                      id="Bairro"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoEndereco.estado"
                      :form="formInfoEmpresa"
                      label="Estado"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoEndereco.cidade"
                      :form="formInfoEmpresa"
                      label="Cidade"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <!-- Avalista -->
    <transition name="fade">
      <template v-if="formAvalista.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="formAvalista.showForm = !formAvalista.showForm"
          >
            4.3 - AVALISTA
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formAvalista.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formAvalista.showForm">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.tipoRelacionamentoEmpresa"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsTipoRelacionamento"
                      label="Tipo de Relacionamento com a Empresa"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-8">
                    <form-helper
                      :inputVar="formAvalista.nomeCompleto"
                      :form="formAvalista"
                      validationType="name"
                      label="Nome Completo"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formAvalista.cpf"
                      :form="formAvalista"
                      validationType="cpf"
                      label="CPF"
                      placeholder="Digite"
                      :mask="'###.###.###-##'"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formAvalista.dataNasc"
                      :form="formAvalista"
                      type="date"
                      validationType="date"
                      label="Data de Nascimento"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.ufOrgaoEmissor"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsUfOrgaoEmissor"
                      label="UF do Orgão do Emissor"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.tipoDocumento"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsTipoDocumento"
                      label="Tipo de Documento"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.numeroDocumento"
                      :form="formAvalista"
                      label="Nº do Documento"
                      :maxlength="10"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.orgaoEmissor"
                      :form="formAvalista"
                      type="select"
                      :options="smp_optionsIssuingBodyDocument"
                      label="Orgão Emissor"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.dataEmissaoDocumento"
                      :form="formAvalista"
                      type="date"
                      validationType="date"
                      label="Data de Emissão"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.sexo"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsSexo"
                      label="Sexo"
                      placeholder="Selecione"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.patrimonio"
                      :form="formAvalista"
                      type="money"
                      label="Patrimônio"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.rendaMensal"
                      :form="formAvalista"
                      type="money"
                      label="Renda Mensal"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formAvalista.email"
                      :form="formAvalista"
                      validationType="email"
                      type="email"
                      label="Email"
                      id="Email"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formAvalista.nomeMae"
                      :form="formAvalista"
                      validationType="name"
                      label="Nome da Mãe"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formAvalista.telefone"
                      :form="formAvalista"
                      label="Telefone Celular"
                      id="TelefoneCelular1"
                      placeholder="(##) #####-####"
                      :mask="'(##) #####-####'"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formAvalista.estadoCivil"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsEstadoCivil"
                      label="Estado Civil"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formAvalista.profissao"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsProfissao"
                      label="Profissão"
                      placeholder="Selecione"
                    />
                  </div>
                  <div v-if="formAvalista.showConjuge">
                    <div class="col-md-6">
                      <form-helper
                        :inputVar="formAvalista.conjuge"
                        :form="formAvalista"
                        validationType="name"
                        label="Nome do Cônjuge"
                        placeholder="Digite"
                      />
                    </div>
                    <div class="col-md-6">
                      <form-helper
                        :inputVar="formAvalista.documentoConjuge"
                        :form="formAvalista"
                        validationType="cpf"
                        label="Nº do Doc. Cônjuge"
                        placeholder="Digite"
                        maxlength="11"
                        :mask="'###########'"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.estado"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsEstado"
                      label="Estado de Nascimento"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.cidade"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsCidade"
                      label="Cidade de Nascimento"
                      placeholder="Selecione"
                      :disabled="formAvalista.disabledCidade"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formAvalista.nacionalidade"
                      :form="formAvalista"
                      type="select"
                      :options="formAvalista.optionsNacionalidade"
                      label="Nacionalidade"
                      placeholder="Selecione"
                    />
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <transition name="fade">
      <template v-if="formEnderecoAvalista.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="
              formEnderecoAvalista.showForm = !formEnderecoAvalista.showForm
            "
          >
            4.4 - INFORMAÇÕES RESIDENCIAIS DO AVALISTA
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formEnderecoAvalista.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formEnderecoAvalista.showForm">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formEnderecoAvalista.cep"
                      :form="formEnderecoAvalista"
                      label="CEP"
                      id="CEP1"
                      placeholder="Digite"
                      :maxlength="8"
                    />
                  </div>
                  <div class="col-md-9">
                    <form-helper
                      :inputVar="formEnderecoAvalista.endereco"
                      :form="formEnderecoAvalista"
                      label="Endereço"
                      id="Endereco1"
                      placeholder="Digite"
                      :disabled="formEnderecoAvalista.disabledEndereco"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formEnderecoAvalista.numero"
                      :form="formEnderecoAvalista"
                      type="number"
                      :min="0"
                      label="Número"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formEnderecoAvalista.complemento"
                      :form="formEnderecoAvalista"
                      label="Complemento"
                      id="Complemento"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formEnderecoAvalista.bairro"
                      :form="formEnderecoAvalista"
                      label="Bairro"
                      id="Bairro1"
                      placeholder="Digite"
                      :disabled="formEnderecoAvalista.disabledEndereco"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formEnderecoAvalista.estado"
                      :form="formEnderecoAvalista"
                      type="select"
                      :options="formEnderecoAvalista.optionsEstado"
                      label="Estado"
                      placeholder="Selecione"
                      :disabled="formEnderecoAvalista.disabledEstado"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formEnderecoAvalista.cidade"
                      :form="formEnderecoAvalista"
                      type="select"
                      :options="formEnderecoAvalista.optionsCidade"
                      label="Cidade"
                      placeholder="Selecione"
                      :disabled="formEnderecoAvalista.disabledCidade"
                    />
                  </div>
                </div>
                <div class="row">
                  <slot name="buttons"></slot>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <!-- Adicionais -->
    <transition name="fade">
      <template v-if="formInfoAdicionais.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="formInfoAdicionais.showForm = !formInfoAdicionais.showForm"
          >
            4.5 - INFORMAÇÕES ADICIONAIS
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formInfoAdicionais.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formInfoAdicionais.showForm">
              <div class="panel-body">
                <div
                  class="row"
                  :style="[
                    formInfoAdicionais.optionsCertifieldAgent.length == 1
                      ? { display: 'none' }
                      : { display: 'block' },
                  ]"
                >
                  <div class="col-md-12">
                    <form-helper
                      :inputVar="formInfoAdicionais.certifieldAgentId"
                      :form="formInfoAdicionais"
                      type="select"
                      :options="formInfoAdicionais.optionsCertifieldAgent"
                      label="Agente Certificado"
                      placeholder="Selecione"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoAdicionais.codigoPedido"
                      :form="formInfoAdicionais"
                      label="Código do Pedido"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-8">
                    <form-helper
                      :inputVar="formInfoAdicionais.comentario"
                      :form="formInfoAdicionais"
                      label="Comentário"
                      placeholder="Digite"
                    />
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <div class="col-md-12">
      <Loader v-if="loaderProposta" />
    </div>
  </main>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.panel-body {
  background: #f3f9ff;
}
</style>

<script>
import FormHelper from "../../FormHelper";
import smp_ from "../../santander/SantanderPropostaMixing";
import axios from "axios";

export default {
  name: "SantanderJuridico",

  props: {
    visible: { type: Boolean, default: false },
    codigoPedido: { type: String, default: "" },
    cliente: { type: Object, default: null },
    token: { type: String, default: null },
    uuid: { type: String, default: null },
    agencia: { default: null },
    conta: { default: null },
    digito: { default: null },
    parcelaQtde: { default: null },
    parcelaValor: { default: null },
    telefone: { default: null },
    dateOfBirthFoundation: { default: null },
    simulacaoId: { default: null },
    valorEntrada: { default: null },
    valorLiberado: { default: null },
    data1aParcela: { default: null },
  },

  components: {
    FormHelper,
  },

  mixins: [smp_],

  data() {
    return {
      formInfoEmpresa: {
        showForm: true,
        showPanel: true,
        razaoSocial: new this.$formInput(true),
        naturezaJuridica: new this.$formInput(true),
        optionsNaturezaJuridica: [],
        grupoAtividadeEconomica: new this.$formInput(true),
        optionsGrupoEconomica: [],
        atividadeEconomica: new this.$formInput(true),
        optionsAtividadeEconomica: [],
        faturamentoMensal: new this.$formInput(true),
        email: new this.$formInput(true),
        telefone: new this.$formInput(true),
        disabledAtividade: true,
        disabledEmail: false,
        attemptSubmit: false,
      },
      formInfoEndereco: {
        showForm: true,
        showPanel: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        cidade: new this.$formInput(true),
        idCidade: 0,
        attemptSubmit: false,
      },
      formInfoAdicionais: {
        showForm: true,
        showPanel: true,
        certifieldAgentId: new this.$formInput(true),
        codigoPedido: new this.$formInput(false),
        comentario: new this.$formInput(false),
        optionsCertifieldAgent: [],
        attemptSubmit: false,
      },
      formAvalista: {
        showForm: true,
        showPanel: true,
        tipoRelacionamentoEmpresa: new this.$formInput(true),
        optionsTipoRelacionamento: [],
        nomeCompleto: new this.$formInput(true),
        cpf: new this.$formInput(true),
        dataNasc: new this.$formInput(true),
        tipoDocumento: new this.$formInput(true),
        optionsTipoDocumento: [],
        numeroDocumento: new this.$formInput(true),
        ufOrgaoEmissor: new this.$formInput(true),
        optionsUfOrgaoEmissor: [],
        dataEmissaoDocumento: new this.$formInput(true),
        orgaoEmissor: new this.$formInput(true),
        sexo: new this.$formInput(true),
        optionsSexo: [],
        patrimonio: new this.$formInput(true),
        rendaMensal: new this.$formInput(true),
        email: new this.$formInput(true),
        telefone: new this.$formInput(true),
        nomeMae: new this.$formInput(true),
        estadoCivil: new this.$formInput(true),
        optionsEstadoCivil: [],
        conjuge: new this.$formInput(false),
        documentoConjuge: new this.$formInput(false),
        profissao: new this.$formInput(true),
        optionsProfissao: [],
        estado: new this.$formInput(true),
        optionsEstado: [],
        cidade: new this.$formInput(true),
        optionsCidade: [],
        disabledCidade: true,
        nacionalidade: new this.$formInput(true),
        optionsNacionalidade: [],
        showConjuge: false,
        attemptSubmit: false,
      },
      formEnderecoAvalista: {
        showForm: true,
        showPanel: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        optionsEstado: [],
        cidade: new this.$formInput(true),
        optionsCidade: [],
        disabledCidade: true,
        disabledEstado: true,
        disabledEndereco: true,
        attemptSubmit: false,
      },
      loader: false,
      loaderProposta: false,
      isLoaded: false,
    };
  },

  methods: {
    unload: async function () {
      this.isLoaded = false;
    },

    load: async function () {
      if (!this.isLoaded) {
        this.loader = true;
        this.formInfoAdicionais.codigoPedido.value = this.codigoPedido;

        this.setDadosEmpresa();
        this.setDadosResidenciais();
        this.formInfoEmpresa.telefone.value = this.telefone;
        this.formInfoEmpresa.optionsGrupoEconomica = await this.getGruposAtividade();
        this.formAvalista.optionsTipoRelacionamento = await this.getTipoRelacionamentoEmpresa();
        this.formInfoEmpresa.optionsNaturezaJuridica = await this.getNaturezasJuridicas();
        this.formAvalista.optionsNacionalidade = await this.getNacionalidades();
        this.formAvalista.optionsTipoDocumento = await this.getTipoDocumento();
        this.formAvalista.optionsEstadoCivil = await this.getEstadosCivis();
        this.formAvalista.optionsSexo = await this.getGeneros();
        this.formAvalista.optionsProfissao = await this.getProfissoes();
        let estadoOptions = await this.getEstados();
        this.formAvalista.optionsUfOrgaoEmissor = estadoOptions;
        this.formEnderecoAvalista.optionsEstado = estadoOptions;
        this.formAvalista.optionsEstado = estadoOptions;

        this.formInfoAdicionais.optionsCertifieldAgent = await this.getCertifiedAgents();
        if (this.formInfoAdicionais.optionsCertifieldAgent.length > 0)
          this.formInfoAdicionais.certifieldAgentId.value = this.formInfoAdicionais.optionsCertifieldAgent[0];

        this.loader = false;
        this.isLoaded = true;
      }
    },

    setDadosEmpresa() {
      this.formInfoEmpresa.razaoSocial.value = this.cliente.CLI_RAZAOSOCIAL;
      this.formInfoEmpresa.email.value = this.cliente.CLI_EMAIL;
    },

    setDadosResidenciais() {
      this.formInfoEndereco.cep.value = this.cliente.CLI_CEP;
      this.formInfoEndereco.endereco.value = this.cliente.CLI_ENDERECO;
      this.formInfoEndereco.bairro.value = this.cliente.CLI_BAIRRO;
      this.formInfoEndereco.estado.value = this.cliente.EST_UF;
      this.formInfoEndereco.cidade.value = this.cliente.CLI_CIDADE;
    },

    async setDadosProposta() {
      if (this.formInfoEndereco.idCidade == 0) {
        this.formInfoEndereco.idCidade = await this.getCidadeId(
          this.formInfoEndereco.estado.value,
          this.formInfoEndereco.cidade.value
        );
      }

      let proposta = {};
      proposta.uuid = this.uuid;

      let additional = {};
      additional.reservationCode = this.codigoPedido;
      additional.comments = this.formInfoAdicionais.comentario.value;
      additional.certifieldAgentId = this.formInfoAdicionais.certifieldAgentId.value.code;

      proposta.additional = additional;

      let customer = {};
      customer.document = this.cliente.CLI_CICCGC;
      customer.dateOfBirthFoundation = this.dateOfBirthFoundation;
      customer.participationType = 1;
      customer.email = this.formInfoEmpresa.email.value;
      customer.name = this.cliente.CLI_RAZAOSOCIAL;

      let address = {};
      address.zipCode = this.formInfoEndereco.cep.value;
      address.street = this.formInfoEndereco.endereco.value;
      address.number = this.formInfoEndereco.numero.value;
      address.complement = this.formInfoEndereco.complemento.value;
      address.neighborhood = this.formInfoEndereco.bairro.value;
      address.state = this.formInfoEndereco.estado.value;
      address.city = this.formInfoEndereco.idCidade;
      address.type = "R";

      customer.address = address;

      let legal = {};
      legal.companySize = "P";
      legal.economicActivity = this.formInfoEmpresa.atividadeEconomica.value.code;
      legal.groupEconomicActivity = this.formInfoEmpresa.grupoAtividadeEconomica.value.code;
      legal.legalNature = this.formInfoEmpresa.naturezaJuridica.value.code;
      legal.monthlyInvoicing = Math.round(
        this.formInfoEmpresa.faturamentoMensal.value
      );

      let guarantor = {};
      guarantor.relationshipTypeCompany = this.formAvalista.tipoRelacionamentoEmpresa.value.code;
      guarantor.birthCity = this.formAvalista.cidade.value.code;
      guarantor.birthState = this.formAvalista.estado.value.code;
      guarantor.dateOfIssue = this.formAvalista.dataEmissaoDocumento.value;
      guarantor.dateOfBirth = this.formAvalista.dataNasc.value;
      guarantor.document = this.formAvalista.cpf.value.replace(
        /[\(\)\.\s-]+/g,
        ""
      );
      guarantor.documentId = this.formAvalista.tipoDocumento.value.code;
      guarantor.documentNumber = this.formAvalista.numeroDocumento.value;
      guarantor.documentState = this.formAvalista.ufOrgaoEmissor.value.code;
      guarantor.email = this.formAvalista.email.value;
      guarantor.gender = this.formAvalista.sexo.value.code;
      guarantor.issuingBodyDocument = this.formAvalista.orgaoEmissor.value.code;
      guarantor.nationality = this.formAvalista.nacionalidade.value.code;
      guarantor.occupation = this.formAvalista.profissao.value.code;
      guarantor.participationType = 3;
      guarantor.maritalStatus = this.formAvalista.estadoCivil.value.code;
      guarantor.monthlyIncome = Math.round(this.formAvalista.rendaMensal.value);
      guarantor.mother = this.formAvalista.nomeMae.value;
      guarantor.name = this.formAvalista.nomeCompleto.value;
      guarantor.patrimony = Math.round(this.formAvalista.patrimonio.value);

      let guarantorAddress = {};
      guarantorAddress.zipCode = this.formEnderecoAvalista.cep.value;
      guarantorAddress.street = this.formEnderecoAvalista.endereco.value;
      guarantorAddress.number = this.formEnderecoAvalista.numero.value;
      guarantorAddress.complement = this.formEnderecoAvalista.complemento.value;
      guarantorAddress.neighborhood = this.formEnderecoAvalista.bairro.value;
      guarantorAddress.state = this.formEnderecoAvalista.estado.value.code;
      guarantorAddress.city = this.formEnderecoAvalista.cidade.value.code;
      guarantorAddress.type = "R";

      guarantor.address = guarantorAddress;

      let guarantorPhone = {};
      let telefone = this.formAvalista.telefone.value.replace(
        /[\(\)\.\s-]+/g,
        ""
      );
      guarantorPhone.ddd = telefone.slice(0, 2);
      guarantorPhone.number = telefone.slice(2);

      guarantor.cellphone = guarantorPhone;

      if (this.formAvalista.showConjuge) {
        let spouse = {};
        spouse.document = this.formAvalista.documentoConjuge.value;
        spouse.name = this.formAvalista.conjuge.value;
        guarantor.spouse = spouse;
      }

      legal.guarantor = guarantor;

      if (this.agencia) {
        let bankReference = {};
        bankReference.agencyCode = this.agencia;
        bankReference.accountCode = this.conta;
        bankReference.accountDigit = this.digito;
        bankReference.bankCode = 33;

        legal.bankReference = bankReference;
      }

      let legalPhone = {};
      telefone = this.formInfoEmpresa.telefone.value.replace(
        /[\(\)\.\s-]+/g,
        ""
      );
      legalPhone.ddd = telefone.slice(0, 2);
      legalPhone.number = telefone.slice(2);

      legal.phone = legalPhone;

      customer.legal = legal;
      proposta.customer = customer;
      return proposta;
    },

    async getCidades(uf, tipo) {
      let options = await this.GetCidadesPorEstado(uf);
      let cidade = null;
      try {
        //let cidade = cidades.filter(c => c.description.includes(this.formInfoResidencial.cidade.value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase()));
        //if (cidade.length > 0)
        //self.formInfoResidencial.idCidade = cidade[0].id

        cidade = this.formEnderecoAvalista.cidade.value.toUpperCase();
      } catch (e) {
        cidade = null;
      }

      if (tipo == "endereco") {
        this.formEnderecoAvalista.cidade = new this.$formInput(true);
        this.formEnderecoAvalista.optionsCidade = [];
      } else {
        this.formAvalista.cidade = new this.$formInput(true);
        this.formAvalista.optionsCidade = [];
      }

      if (tipo == "endereco") {
        this.formEnderecoAvalista.optionsCidade = options;
      } else {
        this.formAvalista.optionsCidade = options;
      }

      if (tipo == "endereco") {
        this.formEnderecoAvalista.disabledCidade = false;

        if (cidade) {
          this.formEnderecoAvalista.cidade.value = this.formEnderecoAvalista.optionsCidade.filter(
            (c) => c.label == cidade
          )[0];
          this.formEnderecoAvalista.disabledCidade = true;
        }
      } else this.formAvalista.disabledCidade = false;
    },

    async getCepInfos(cep) {
      const self = this;
      let cepInfo = await this.getCepInfo(cep);
      if (!cepInfo) {
        self.formEnderecoAvalista.endereco.value = "";
        self.formEnderecoAvalista.bairro.value = "";
        self.formEnderecoAvalista.disabledEndereco = true;

        self.formEnderecoAvalista.estado.value = "";
        self.formEnderecoAvalista.cidade.value = "";

        self.formEnderecoAvalista.disabledEstado = true;
        self.formEnderecoAvalista.disabledCidade = true;
        return;
      } else {
        if (cepInfo.street) {
          self.formEnderecoAvalista.endereco.value = cepInfo.street;
          self.formEnderecoAvalista.bairro.value = cepInfo.district;
          self.formEnderecoAvalista.disabledEndereco = true;
        } else {
          self.formEnderecoAvalista.endereco.value = "";
          self.formEnderecoAvalista.bairro.value = "";
          self.formEnderecoAvalista.disabledEndereco = false;
        }

        if (cepInfo.state) {
          self.formEnderecoAvalista.disabledCidade = true;
          let estado = self.formEnderecoAvalista.optionsEstado.filter(
            (c) => c.code == cepInfo.state
          )[0];
          if (estado) {
            self.formEnderecoAvalista.estado.value = estado;
            self.formEnderecoAvalista.disabledEstado = true;
          }
          setTimeout(() => {
            let cidade = self.formEnderecoAvalista.optionsCidade.filter(
              (c) => c.label == self.removeAcento(cepInfo.city).toUpperCase()
            )[0];
            if (cidade) {
              self.formEnderecoAvalista.cidade.value = cidade;
            } else {
              self.formEnderecoAvalista.disabledCidade = false;
            }
          }, 1000);
        } else {
          self.formEnderecoAvalista.disabledEstado = false;
          self.formEnderecoAvalista.disabledCidade = false;
        }
      }
    },

    removeAcento(text) {
      text = text.toLowerCase();
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      return text;
    },

    async sendProposta() {
      const self = this;
      self.loaderProposta = true;
      self.formInfoEmpresa.attemptSubmit = true;
      self.formInfoEndereco.attemptSubmit = true;
      self.formAvalista.attemptSubmit = true;
      self.formEnderecoAvalista.attemptSubmit = true;
      self.formInfoAdicionais.attemptSubmit = true;

      if (this.formErrors === 0) {
        let proposta = await self.setDadosProposta();
        return await axios
          .post(
            self.$apiUrl + "Santander.svc/proposal",
            {
              proposta: proposta,
              numeroParcelas: self.parcelaQtde,
              valorParcelas: self.parcelaValor,
              token: self.token,
              codigoPedido: self.codigoPedido.split("-")[0] * 1,
              simulacaoId: self.simulacaoId,
              valorEntrada: self.valorEntrada,
              valorLiberado: self.valorLiberado,
              data1aParcela: self.data1aParcela,
            },
            { withCredentials: true }
          )
          .then(async (response) => {
            let r = await self.reCallOnError(
              response.data,
              self,
              self.sendProposta
            );
            if (r) return r;
            self.loaderProposta = false;
            return await self.processaRespostaPropostaJuridico(response, self);
          })
          .catch(() => {
            self.loaderProposta = false;
          });
      } else {
        swal({
          title: "Preencha os campos obrigatórios",
          text: "Números de campos a serem preenchidos: " + self.formErrors,
          icon: "warning",
        });
        self.loaderProposta = false;
      }
      return null;
    },
  },

  watch: {
    visible: function (val) {
      if (val) {
        this.load();
      } else {
        this.unload();
      }
    },

    "formInfoEmpresa.grupoAtividadeEconomica.value": async function (val) {
      if (val) {
        this.formInfoEmpresa.optionsAtividadeEconomica = await this.getAtividadesEconomica(
          val.code
        );
        this.formInfoEmpresa.atividadeEconomica = new this.$formInput(true);
        this.formInfoEmpresa.disabledAtividade = false;
      } else {
        this.formInfoEmpresa.atividadeEconomica = new this.$formInput(true);
        this.formInfoEmpresa.disabledAtividade = true;
      }
    },

    "formEnderecoAvalista.estado.value": function (val) {
      if (val) this.getCidades(val.code, "endereco");
      else {
        this.formEnderecoAvalista.cidade = new this.$formInput(true);
        this.formEnderecoAvalista.disabledCidade = true;
      }
    },

    "formAvalista.estado.value": function (val) {
      if (val) this.getCidades(val.code, "nascimento");
      else {
        this.formAvalista.cidade = new this.$formInput(true);
        this.formAvalista.disabledCidade = true;
      }
    },

    "formEnderecoAvalista.cep.value": function (val) {
      if (val.length == 8) this.getCepInfos(val);
    },

    "formAvalista.estadoCivil.value": function (val) {
      if (val.code == 1 || val == "CASADO") {
        this.formAvalista.conjuge = new this.$formInput(true);
        this.formAvalista.documentoConjuge = new this.$formInput(true);

        this.formAvalista.showConjuge = true;
      } else {
        this.formAvalista.conjuge = new this.$formInput(false);
        this.formAvalista.documentoConjuge = new this.$formInput(false);

        this.formAvalista.showConjuge = false;
      }
    },
  },

  computed: {
    formErrors: function () {
      let totalErrors = 0;

      let errors = Object.keys(this.formInfoEmpresa).filter(
        (key) =>
          this.formInfoEmpresa[key].validation &&
          !this.formInfoEmpresa[key].validation.status
      );
      totalErrors += errors.length;

      errors = Object.keys(this.formInfoEndereco).filter(
        (key) =>
          this.formInfoEndereco[key].validation &&
          !this.formInfoEndereco[key].validation.status
      );
      totalErrors += errors.length;

      errors = Object.keys(this.formInfoAdicionais).filter(
        (key) =>
          this.formInfoAdicionais[key].validation &&
          !this.formInfoAdicionais[key].validation.status
      );
      totalErrors += errors.length;

      errors = Object.keys(this.formAvalista).filter(
        (key) =>
          this.formAvalista[key].validation &&
          !this.formAvalista[key].validation.status
      );
      totalErrors += errors.length;

      errors = Object.keys(this.formEnderecoAvalista).filter(
        (key) =>
          this.formEnderecoAvalista[key].validation &&
          !this.formEnderecoAvalista[key].validation.status
      );
      totalErrors += errors.length;

      return totalErrors;
    },
  },
};
</script>